var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"position":"is-bottom-right","mobile-modal":false},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('b-button',[_vm._v(_vm._s(_vm.label))])]},proxy:true}])},[_vm._v(" "),_vm._t("dropdown-items")],2)}
var staticRenderFns = []

export { render, staticRenderFns }